/**
 * String constants mapping to values stored in browser local storage
 */
enum LocalStorageKey {
    Identity = "Identity",
    SystemSettings = "SystemSettings",
    NetworkState = "NetworkState",
    RefreshToken = "RefreshToken",
    ExternalTopics = "ExternalTopics",
    AuthStrategyType = "AuthStrategyType",
    IdentityProvider = "IdentityProvider",
    UserDashboardLeftColumnWidthInVw = "UserDashboardLeftColumnWidthInVw",
    NotebookLayoutReferencePanelWidthInVw = "NotebookLayoutReferencePanelWidthInVw",
    NotebookCallToActionDismissed = "NotebookCallToActionDismissed",
    Conversations = "conversations",
    EmulationOriginalUserLogin = "Original_UserLogin",
    EmulationToken = "token",
}

export default LocalStorageKey;
